import { Grid, Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import { Gift } from 'src/modules/gift/models/gift';
import { PaymentTypeEnum } from 'src/modules/gift/models/paymentType.enum';
import { useTranslation } from 'react-i18next';
import dayjs from 'dayjs';
import GridWrapper from 'src/shared/components/organisms/gridWrapper';
import { ContentSection } from 'src/shared/components/organisms/contentSection';
import { AmountWithCurrency } from 'src/shared/components/atoms/amountWithCurrency';

interface GiftDetailInvoiceProps {
  gift: Gift;
}

type DisplayDetailProps = {
  label: string;
  value: string | undefined;
  link?: string;
};

const DisplayDetail = (props: DisplayDetailProps) => {
  const { label, value, link = undefined } = props;
  return value ? (
    <Grid item xs zeroMinWidth>
      <Typography variant='body1' component='div' sx={{ fontWeight: 500 }}>
        {label.replace(/<BR>/gi, '')}
      </Typography>
      {link ? (
        <Link to={link}>{value}</Link>
      ) : (
        <Typography variant='body1' component='div'>
          {value}
        </Typography>
      )}
    </Grid>
  ) : null;
};

export const GiftDetailInvoice = (props: GiftDetailInvoiceProps) => {
  const { gift } = props;
  const { t } = useTranslation(['gift']);

  return (
    <ContentSection>
      <GridWrapper>
        <Grid item xs={12}>
          <Typography variant='h4' sx={{ fontWeight: 600 }}>
            <AmountWithCurrency amount={gift.amount} />
            {/* {gift.invoice?.paid && ` (${formatAmountToFixedKr(gift.invoice?.paid)})`} */}
          </Typography>
        </Grid>
        <DisplayDetail
          label={t('gift:paymentDetail.payDate')}
          value={gift.invoice?.paidDate ? `${dayjs(gift.invoice?.paidDate).format('YYYY-MM-DD')}` : 'Ej Betalad'}
          key='paidDate'
        />
        <DisplayDetail
          label={t('gift:paymentDetail.ocr')}
          value={gift.invoice?.ocr}
          key='ocr'
          link={`/invoicing/invoices/${gift.invoice?.invoice_id}`}
        />
        <DisplayDetail label={t('gift:paymentDetail.paymentMethod')} value={PaymentTypeEnum[gift.paymentMethod]} key='paymentType' />
      </GridWrapper>
    </ContentSection>
  );
};
